"use client";

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const faqs = [{
    question: "What is included in a home inspection?",
    answer: "A home inspection is a visual evaluation of accessible systems and components, including the roof, exterior, interior, attic when accessible, electrical, plumbing, HVAC, appliances, and visible moisture concerns."
  }, {
    question: "How long does a home inspection take?",
    answer: "Most home inspections take about 1.5 to 3 hours depending on the property size, age, condition, and add‑on services requested."
  }, {
    question: "When will I receive my report?",
    answer: "Reports are typically delivered within 24 hours, and often the same day when scheduling and report workload allow."
  }, {
    question: "Do you offer wind mitigation and 4‑point inspections?",
    answer: "Yes. Trusted Inspections provides wind mitigation and 4‑point inspections commonly requested by Florida insurance carriers."
  }, {
    question: "Do you offer mold testing or sewer camera inspections?",
    answer: "Yes. Mold testing and sewer camera inspections are available as add‑on services when requested."
  }, {
    question: "Do I need to attend the inspection?",
    answer: "Attendance is not required, but buyers and agents are welcome to attend near the end of the inspection for a summary of the main findings."
  }];
  return <section data-section-id="28440" id="frequently-asked-questions" ref={ref} className={cn("py-40 bg-background w-full transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-5xl font-semibold text-center mb-16 tracking-tight text-foreground">
            Frequently Asked Questions
          </h2>

          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} className="border-b border-border/60 last:border-0 px-2" data-index={i}>
                <AccordionTrigger className="text-xl font-medium text-foreground hover:text-primary hover:no-underline transition-colors py-6 text-left [&[data-state=open]]:text-primary">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-lg leading-relaxed pb-6">
                  <div className="animate-in fade-in slide-in-from-top-2 duration-[400ms] ease-out">
                    {faq.answer}
                  </div>
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}